import { useTranslation } from 'react-i18next';

import optainLogoImg from 'src/assets/icons/logo-b/optain.png';

import {
  CustomModal,
  CustomModalHeader,
  CustomModalTitle,
} from 'src/components/custom_components/CustomModal';

import { I18NextNS } from 'src/models/Language.model';

interface LoginContainerProps {
  children: React.ReactNode;
}

const LoginContainer = ({ children }: LoginContainerProps) => {
  const { t } = useTranslation(I18NextNS.PAGES);

  return (
    <CustomModal show overlayClassName="bg-solid">
      <CustomModalHeader>
        <CustomModalTitle>
          <img
            src={optainLogoImg}
            alt="Logo"
            width={50}
            className="object-fit-contain"
          />
          <span className="ms-2">{t('loginLogout.title')}</span>
        </CustomModalTitle>
      </CustomModalHeader>
      {children}
    </CustomModal>
  );
};

export default LoginContainer;
